export const ORDER_STATUS = {
  PAYMENT_PENDING: 10,
  ORDER_BEING_PROCESSED: 20,
  PARTIALLY_FULFILLED: 30,
  FULFILLED: 40,
  DELIVERED: 50,
  LEAVE_A_COMMENT: 60,
  CANCELLED: 70,
  CLOSED: 80,
  REFUNDED: 110
}

export const ORDER_OVER_RALL_FIT_MAP = {
  "1" :'core.order.orderReview.small',
  "2" : 'core.order.orderReview.trueToSize',
  "3" : 'core.order.orderReview.large'
}

export const ORDER_STATUS_DESC = {
  [ORDER_STATUS.PAYMENT_PENDING]: {
    title: 'core.order.statusDesc.pending.title',
    subtitle: 'core.order.statusDesc.pending.subtitle'
  },
  [ORDER_STATUS.ORDER_BEING_PROCESSED]: {
    title: 'core.order.statusDesc.confirmed.title',
    subtitle: 'core.order.statusDesc.confirmed.subtitle'
  },
  [ORDER_STATUS.PARTIALLY_FULFILLED]: {
    title: 'core.order.statusDesc.shipped.title',
    subtitle: 'core.order.statusDesc.shipped.subtitle'
  },
  [ORDER_STATUS.FULFILLED]: {
    title: 'core.order.statusDesc.shipped.title',
    subtitle: 'core.order.statusDesc.shipped.subtitle'
  },
  [ORDER_STATUS.LEAVE_A_COMMENT]: {
    title: 'core.order.statusDesc.review.title',
    subtitle: 'core.order.statusDesc.review.subtitle'
  },
  [ORDER_STATUS.DELIVERED]: {
    title: 'core.order.statusDesc.completed.title',
  },
  [ORDER_STATUS.CANCELLED]: {
    title: 'core.order.statusDesc.cancelled.title',
  },
  [ORDER_STATUS.CLOSED]: {
    title: 'core.order.statusDesc.closed.title',
  },
  [ORDER_STATUS.REFUNDED]: {
    title: 'core.order.statusDesc.refunded.title',
  },
}

export const canCommentOnOrder = ({ status }) => {
  return status === ORDER_STATUS.LEAVE_A_COMMENT || status === ORDER_STATUS.FULFILLED
}

export const canContinuePayOnOrder = ({ status }) => {
  return status === ORDER_STATUS.PAYMENT_PENDING
}

// for login user, get user email. if not, get address email
export const getLoginUserOrderEmail = ($user, userAddress) => {
  if ($user && $user.hasLogin()) {
    return $user.getUserEmail() || userAddress?.email
  }
}